import { Builder } from '@builder.io/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import dayjs from 'dayjs'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useState, useEffect } from 'react'
import Slider from 'react-slick'
import LinkRoute from '../../ui/link/Link'

import './index.css'
import ListBox from '../common/list-box'

interface Props {
  backgroundColor: string
  blogItemBackgroundColor: string
  blogItemTitleColor: string
  blogItemDescriptionColor: string
  authorNameColor: string
  articleDateColor: string
  maxNumberToList: number
  autoplayTime: number
  isCarousel: boolean
  showSearchFilter: boolean
}

const BlogLister = ({
  backgroundColor,
  blogItemBackgroundColor,
  blogItemTitleColor,
  blogItemDescriptionColor,
  authorNameColor,
  articleDateColor,
  maxNumberToList,
  autoplayTime,
  isCarousel,
  showSearchFilter
}: Props) => {
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props
    return (
      <ChevronRightIcon
        onClick={onClick}
        className={`${className} blog-lister-chevron-right h-5 w-5 sm:h-6 sm:w-6`}
        style={style}
      />
    )
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props
    return (
      <ChevronLeftIcon
        onClick={onClick}
        className={`${className} blog-lister-chevron-left h-5 w-5 sm:h-6 sm:w-6`}
        style={style}
      />
    )
  }

  const [carouselSettings, setCarouselSettings] = useState({
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  })

  const [activeBlogFilter, setActiveBlogFilter] = useState('all')

  useEffect(() => {
    setCarouselSettings({
      dots: false,
      autoplay: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      autoplaySpeed: autoplayTime
    })
  }, [autoplayTime, backgroundColor])

  const { allBuilderModels }: any = useStaticQuery(graphql`
    query {
      allBuilderModels {
        blogArticle (limit: 50) {
          data {
            date
            title
            url
            description
            coverImage
            cdnCoverImage
            author
          }
        }
        author {
          data {
            authorName
            photo
          }
          id
        }
      }
    }
  `)

  console.log('--- Blog Lister - BlogArticles ---', allBuilderModels.blogArticle)
  console.log('--- Blog Lister - BlogAuthors ---', allBuilderModels.author)

  // function getLang() {
  //   if (navigator.languages != undefined) return navigator.languages[0]
  //   return navigator.language
  // }

  const dateFormatted = (date: any) => {
    const dateObj = new Date(date)
    const dateStr = dayjs(dateObj).format('D MMMM YYYY') // dateObj.toLocaleDateString(getLang())
    return dateStr
  }

  const renderBlogs = () => {
    const blogArticals =
      maxNumberToList === 0 || !maxNumberToList
        ? allBuilderModels.blogArticle
        : allBuilderModels.blogArticle?.slice(0, maxNumberToList)
    return blogArticals
      ?.filter((item: any) => {
        if (activeBlogFilter.toLowerCase() === 'all') {
          return item
        }

        return activeBlogFilter === item.data.description
      })
      .map((item: any, i: number) => {
        const post = item.data
        const authorId = post.author.id
        const author = allBuilderModels.author?.filter((autho: any) => autho.id === authorId)[0]

        // extract public id for Cloudinary
        const [, publicId = ''] =
          post?.coverImage?.match(
            /^https:\/\/res\.cloudinary\.com\/different-dog\/image\/upload\/[a-z0-9]+\/(.*)\..*$/
          ) || []

        return (
          <div
            key={i}
            className="flex flex-col overflow-hidden rounded-3xl"
            style={{ backgroundColor: backgroundColor }}
          >
            <div className="flex-shrink-0">
              <>
                {post.cdnCoverImage ? (
                  <CdnImage
                    className="h-48 w-full object-cover"
                    url={post.cdnCoverImage}
                    alt={post.title}
                    steps={[414]}
                  />

                  //   <CdnImage
                  //     className="h-48 w-full object-cover"
                  //     url={post.cdnCoverImage}
                  //     alt={post.title}
                  //     steps={[414]}
                  //   />
                  // ) : post.coverImage.includes('https://res.cloudinary.com') ? (
                  //   <CloudinaryImage
                  //     className="h-48 w-full object-cover"
                  //     publicId={publicId.replace(/%20/g, ' ')}
                  //     alt={post.title}
                  //     steps={[414]}
                  //   />
                ) : (
                  <img className="h-48 w-full object-cover" src={post.coverImage} alt={post.title} />
                )}
              </>
            </div>
            <div
              className="flex flex-1 flex-col justify-between p-6"
              style={{ backgroundColor: blogItemBackgroundColor }}
            >
              <div className="flex-1">
                <LinkRoute href={post.url} className="mt-2 block" target="_blank" style={{ textDecoration: 'none' }}>
                  <p className="mt-3 mb-4 text-base text-gray-500" style={{ color: blogItemDescriptionColor }}>
                    {post.description}
                  </p>
                  <h5
                    className="text-xl font-semibold text-gray-900 hover:underline"
                    style={{ color: blogItemTitleColor }}
                  >
                    {post.title}
                  </h5>
                </LinkRoute>
              </div>
              <div className="mt-6 flex items-center">
                <div className="flex-shrink-0">
                  <span className="sr-only">{author?.data?.name}</span>
                  {/* <img
                  className="h-10 w-10 rounded-full"
                  src={author?.data?.photo}
                  alt=""
                  style={{ objectFit: 'cover' }}
                /> */}
                  {/* <a href={post.author.href}>
                  </a> */}
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900" style={{ color: authorNameColor }}>
                    {author?.data?.name}
                    {/* <a href={post.author.href} className="hover:underline">
                    </a> */}
                  </p>
                  <div className="flex space-x-1 text-base text-gray-500" style={{ color: articleDateColor }}>
                    {/* <time dateTime={post.datetime}>{post.date}</time> */}
                    <span>{dateFormatted(post.date)}</span>
                    {/* <span aria-hidden="true">&middot;</span> */}
                    {/* <span>{post.readingTime} read</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })
  }

  const renderBlogFilterDropdown = () => {
    const blogArticles =
      maxNumberToList === 0 || !maxNumberToList
        ? allBuilderModels.blogArticle
        : allBuilderModels.blogArticle?.slice(0, maxNumberToList)

    return (
      <div className="mx-auto w-full md:w-[300px]">
        <ListBox
          items={[{ key: 'all', value: 'All' }]
            .concat(blogArticles.map((b: any) => ({ key: b.data.description, value: b.data.description })))

            // Remove duplicates - more complex then it should be!
            //@ts-ignore
            .map(JSON.stringify)
            .reverse()
            .filter((item, i, arr) => arr.indexOf(item, i + 1) === -1)
            //@ts-ignore
            .reverse()
            .map(JSON.parse)}
          onItemSelected={item => {
            setActiveBlogFilter(item)
          }}
        />
      </div>
    )
  }

  return (
    <div
      className={`relative px-8 ${showSearchFilter ? 'pt-4 lg:pt-8' : 'pt-0'} pb-4 sm:px-4 lg:px-8  lg:pb-8`}
      style={{ backgroundColor }}
    >
      <div className={`relative mx-auto ${isCarousel ? 'hidden' : 'block'} max-w-7xl md:block`}>
        {showSearchFilter && <div>{renderBlogFilterDropdown()}</div>}
        <div className="mx-auto mt-8 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">{renderBlogs()}</div>
      </div>
      {isCarousel && (
        <div className="relative block md:hidden">
          <Slider {...carouselSettings}>{renderBlogs()}</Slider>
        </div>
      )}
    </div>
  )
}

export default BlogLister

Builder.registerComponent(BlogLister, {
  name: 'BlogLister',
  inputs: [
    {
      name: 'maxNumberToList',
      type: 'number',
      defaultValue: 0,
      description: 'Default is set to 0. When its 0 the component will display all blogs that are available.'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#F9F5F1'
    },
    {
      name: 'blogItemBackgroundColor',
      type: 'color',
      defaultValue: '#cfcfcf'
    },
    {
      name: 'blogItemTitleColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'blogItemDescriptionColor',
      type: 'color',
      defaultValue: 'brown'
    },
    {
      name: 'authorNameColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'articleDateColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'autoplayTime',
      type: 'number',
      defaultValue: 3000
    },
    {
      name: 'isCarousel',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'showSearchFilter',
      type: 'boolean',
      defaultValue: true
    }
  ]
})
